/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

const FcsPermissionCariSTT = {
  permission_cari_stt_list_enabled: new FcsFlag.Flag(false),
  permission_cari_stt_scan_enabled: new FcsFlag.Flag(false)
};

export const FlagsPermissionCariSTT = {
  ...FcsPermissionCariSTT
};

export function initFlagsPermissionCariSTT() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureCariStt", FcsPermissionCariSTT);
}
